const QuestionPreviewTypes = {
  assignmentPreview: 'assignmentPreview',
  editAssignmentPreview: 'editAssignmentPreview',
  classRoomPreview: 'classRoomPreview',
  questionPreview : 'questionPreview'
};
  
export default QuestionPreviewTypes;